import React from "react";

export default function CustomRatingLabel({ rating }) {
  return (
    <div className="stars">
      {Array.from({ length: 5 }, (_, index) => (
        <i
          key={index}
          className={`fa-solid fa-star ${index < rating ? "active" : ""}`}
          aria-hidden="true"
        ></i>
      ))}
    </div>
  );
}
